export const INLINE_BLOCK_EDITOR_NAME = 'inline-block-edit';
